import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, InjectionToken } from '@angular/core';

import { Subject } from 'rxjs';

export const DRAWER_DATA = new InjectionToken('VeratrakDrawerData');

export interface DrawerOpenEvent<T> {
  template: ComponentType<T>;
  data: unknown;
  width?: string;
}

@Injectable({ providedIn: 'root' })
export class DrawerService<Template, CloseReason = { id: string; reason: string }> {
  private openedSource = new Subject<DrawerOpenEvent<Template>>();
  private closedSource = new Subject<CloseReason | undefined>();

  opened$ = this.openedSource.asObservable();
  closed$ = this.closedSource.asObservable();

  open(template: ComponentType<Template>, data?: unknown, options?: { width?: string }): void {
    this.openedSource.next({ template, data, width: options?.width });
  }

  close(reason?: CloseReason): void {
    this.closedSource.next(reason);
  }
}
